module.exports = __webpack_public_path__ + "static/media/adam-book-thumbnail.dda2c6be.png";